module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0689.7705eb26.jpg";